import React, { useEffect, useRef, useState,useContext } from "react";
import { useNavigate } from 'react-router-dom';

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useOnboarding } from "../../context/OnboardingContext";
import JWTContext from '../../context/JWTContext';
import { SubmitHandler, useForm } from "react-hook-form";

const schema = yup.object({
    email: yup.string().email().required(),
    shopName: yup.string().required(),
    phone:yup.string().required()
}).required();

const ShopInformation = (  ) => {
   const navigate = useNavigate();
   const { saveStep,data } = useOnboarding();

   const { register: registerAccount } = useContext(JWTContext);


         const {
             register,
             handleSubmit,
             reset,
             
             setValue,
             formState: { errors }
         } = useForm({
             resolver: yupResolver(schema),
              defaultValues: {
                  bussinesstype: data.bussinesstype ?? "",
                    ownerName: data.ownerName ?? "",
                    citizenID: data.citizenID ?? "",
                    agreement: data.agreement ?? false,
                    email: data.email ?? "",
                    shopName: data.shopName ?? "",
                    phone: data.phone ?? "",
                    phoneCC: data.phone ?? "+62"
             }
         });

    const readUserData=()=> {
        if(localStorage.getItem('user')==null){
            navigate("/login")
        } 
    }


   const onSubmit = (data) => {
        saveStep({
            email: data.email,
            shopName: data.shopName,
            phone: data.phone
        });
        navigate("/registration-shop-summary");
    };

        useEffect(() => {
            readUserData();
        },[]);

  return (
    <div className="document-verification text_quicksand">
        <div className="container">
           <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group mb-40">
                    <label className="form-label fw-bold mb-10">Shop Name <span className="text-danger">*</span></label>
                    <input type="text" className="form-control p-10" {...register("shopName")} placeholder="Enter your shop name" />
                </div>
                <div className="form-group mb-40">
                    <label className="form-label fw-bold mb-10">Email <span className="text-danger">*</span></label>
                    <input type="text" className="form-control p-10" {...register("email")} placeholder="Enter your email" />
                </div>
                <div className="form-group mb-60">
                    <label className="form-label fw-bold mb-10">Phone number <span className="text-danger">*</span></label>
                    <input type="text" className="form-control p-10" {...register("phone")} placeholder="Enter your phone number" />
                </div>



                <div className="d-flex justify-content-between">
                    {/* <button className="btn btn_mart_secondary" type="button" onClick={() => navigate("/registration-document-verification")}>Previous</button>
                    <button className="btn btn_mart_primary" type="submit" onClick={() => navigate("/registration-shop-summary")}>Next</button> */}
                    <button className="btn btn_mart_secondary" type="button" onClick={() => navigate("/registration-document-verification")}>Previous</button>
                    <button className="btn btn_mart_primary" type="submit" >Next</button>
                </div>
           </form>
           
        </div>
    </div>
  );
};

export default ShopInformation;